import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function NotesIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99133 2.00783H5.556C4.18333 2.00783 3 3.1205 3 4.49383V11.6358C3 13.0865 4.106 14.2432 5.556 14.2432H10.882C12.2553 14.2432 13.368 13.0098 13.368 11.6358V5.52517L9.99133 2.00783Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81592 2.00002V3.93935C9.81592 4.88602 10.5819 5.65402 11.5279 5.65602C12.4059 5.65802 13.3039 5.65869 13.3646 5.65469"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.68931 10.5384H6.09131"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32864 7.23696H6.09131"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>

  );
}
